import styled from "styled-components";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { IconField } from "primereact/iconfield";

export const Container = styled.div<{ invalid?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  background: transparent;
  border: 1px solid #d1d5db;
  border: 1px solid ${({ invalid }) => (invalid ? "#f44336" : "#d1d5db")};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  transition: border-color 0.2s;

  &:focus-within {
    border-color: #8b5cf6;
    box-shadow: 0 0 0 0.2rem #ddd6fe;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const StyledDropdown = styled(Dropdown)`
  flex: 1;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;

  .p-dropdown {
    width: 100%;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .p-dropdown-label {
    padding: 10px 10px 10px 0 !important;
    font-family: ${({ theme }) => theme.fonts.body};
    color: ${({ theme }) => theme.colors.text} !important;
    font-size: ${({ theme }) => theme.typography.body.fontSize};
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  .p-dropdown-label.p-placeholder {
    color: ${({ theme }) => theme.colors.placeholder} !important;
  }

  .p-dropdown-trigger {
    width: 2.5rem;
    color: ${({ theme }) => theme.colors.darkGrey} !important;
    background: transparent !important;
    border: none !important;
  }

  .p-focus {
    box-shadow: none !important;
    outline: none !important;
  }

  .p-dropdown-panel {
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    margin-top: 4px;
  }

  .p-dropdown-item {
    padding: 0.5rem 1rem;
    font-family: ${({ theme }) => theme.fonts.body};
    color: ${({ theme }) => theme.colors.text};
    transition: background 0.2s;

    &:hover {
      background: ${({ theme }) => theme.colors.primary || "#f0f0f0"};
    }
  }

  .p-dropdown-item.p-highlight {
    background: ${({ theme }) => theme.colors.primary}22;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const CustomInputIcon = styled.span`
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 1rem;
  margin-top: -0.6rem;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  .i:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const NumberContainer = styled.div<{ invalid?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid
    ${({ theme, invalid }) =>
      invalid
        ? theme.colors.error || "#f44336"
        : theme.colors.borderColor || "#ced4da"};
  border-radius: ${({ theme }) => theme.borderRadius.medium || "8px"};
  background: transparent !important;
  transition: border-color 0.2s, box-shadow 0.2s;
  overflow: hidden;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primary}22;
  }
`;

export const StyledInputNumber = styled(InputNumber)`
  flex: 1;
  border: none;
  background: transparent;

  .p-inputnumber-input {
    width: 100%;
    border: none !important;
    padding: 0.5rem 0 0.5rem 0.75rem;
    font-family: ${({ theme }) => theme.fonts.body};
    font-size: ${({ theme }) => theme.typography.body.fontSize};
    color: ${({ theme }) => theme.colors.text};
    background: transparent !important;
    outline: none;
    box-shadow: none;
  }
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.secondary};
  border: none;
  cursor: pointer;
  padding: 0.75rem 0.75rem;
  transition: color 0.2s;

  &:hover {
    background-color: var(--primary-100);
  }

  &:focus {
    outline: none;
  }
`;
export const StyledIconField = styled(IconField)`
  @media (max-width: 400px) {
    width: 100%;
  }
`;
